module.exports = __webpack_public_path__ + "img/empty-groups-dark.f6fad756.svg";